module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAhklEQVR4AWOgC0htX/Pl28//RACoBkHXOoPY/lNXH5GgAYhE3Bs6F+//8/cvURrgyLNwzoPn7whrQEbyAW2r914kQYOwS22zpst1ESlMhEWDlHPlfCUziDRhDSoOpevl9CByhDWY2OQckFKDSBDW4GmedE5MHiJKWEOqQchVUWkgn7CGQQkAGNb9DmOz6LoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CZ.png
// module id = 1121
// module chunks = 0